import { DungChungService } from './../../../dung-chung/__services/dung-chung.service';
import {Component, 
		OnInit, 
		ElementRef, 
		ViewChild, 
		ChangeDetectionStrategy, 
		ChangeDetectorRef, 
		HostListener, 
		ViewChildren, 
		ViewRef} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
// Material
import { MatPaginator, MatSort, MatDialog, MatTableDataSource, MatMenuTrigger } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragStart, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
// RXJS
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { ReplaySubject, fromEvent, merge, BehaviorSubject } from 'rxjs';
//Datasource
import { DeNghiMuaHangDataSource } from '../de-nghi-mua-hang-datasource/de-nghi-mua-hang.datasource';
//Service
import { DeNghiMuaHangService } from '../de-nghi-mua-hang-service/de-nghi-mua-hang.service';
import { SubheaderService } from '../../../../../../core/_base/layout';
import { LayoutUtilsService, QueryParamsModel, MessageType } from '../../../../../../core/_base/crud';
//Model
import { DeNghiMuaHang, DeNghiMuaHangCT } from '../de-nghi-mua-hang-model/de-nghi-mua-hang.model';
import { CommonConFig } from '../../../dung-chung/__model/common_config.model';

//Component
import { DeNghiMuaHangAddEditComponent } from '../de-nghi-mua-hang-add-edit/de-nghi-mua-hang-add-edit.component';
import { DeNghiMuaHangDetailComponent } from '../de-nghi-mua-hang-detail/de-nghi-mua-hang-detail.component';
import { XacNhanMuaHangComponent } from '../xac-nhan-mua-hang/xac-nhan-mua-hang.component';
import { DuyetDeNghiMuaHangComponent } from '../duyet-de-nghi-mua-hang/duyet-de-nghi-mua-hang.component';
import { DuyetGiaComponent } from '../duyet-gia-de-nghi/duyet-gia-de-nghi.component';
import { HC_DangKyTiepKhachService } from '../../../hanh-chanh/hc-dang-ky-tiep-khach/hc-dang-ky-tiep-khach-service/hc-dang-ky-tiep-khach.service';
import { TokenStorage } from 'app/core/auth/_services/token-storage.service';

@Component({
	selector: 'm-de-nghi-mua-hang-list',
	templateUrl: './de-nghi-mua-hang-list.component.html',
	styleUrls: ['../de-nghi-mua-hang.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers:[DatePipe]
})
export class DeNghiMuaHangListComponent implements OnInit {

	/*Config Form */
	CONFIG: CommonConFig;

	// Table fields
	dataSource: DeNghiMuaHangDataSource;
	displayedColumns = [];
	availableColumns = [
        {
			stt: 1,
			name: '#',
			displayName: '#',
			alwaysChecked: false,
			isShow: true
        },
        {
            stt: 2,
            name: 'SoPhieu',
            displayName: 'Số phiếu',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 3,
            name: 'LoaiPhieu',
            displayName: 'Loại phiếu',
            alwaysChecked: false,
			isShow: true
        },
        // {
        //     stt: 4,
        //     name: 'TenPhongBan',
        //     displayName: 'Phòng ban',
        //     alwaysChecked: false,
		// 	isShow: true
        // },
        // {
        //     stt: 5,
        //     name: 'NgayDeNghiCoHang',
        //     displayName: 'Ngày cần',
        //     alwaysChecked: false,
		// 	isShow: true
		// },
		{
            stt: 6,
            name: 'TenNguoiYeuCau',
            displayName: 'Người lập phiếu',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 7,
            name: 'NgayTao',
            displayName: 'Ngày lập phiếu',
            alwaysChecked: false,
			isShow: true
		},
		// {
        //     stt: 8,
        //     name: 'TongTien',
        //     displayName: 'Tổng tiền',
        //     alwaysChecked: false,
		// 	isShow: true
		// },
		{
            stt: 9,
            name: 'DienGiaiLyDo',
            displayName: 'Lý do đề nghị mua',
            alwaysChecked: false,
			isShow: true
		},
		{
            stt: 10,
            name: 'TenTinhTrang',
            displayName: 'Trạng thái',
            alwaysChecked: false,
			isShow: true
        },
        {
            stt: 99,
            name: 'actions',
            displayName: 'Thao tác',
			alwaysChecked: true,
			isShow: true
        }
	];

	@ViewChildren('focus') focus ;
	@ViewChildren('searchFullText') searchFullText;
	@ViewChild('sort1', {static: true}) sort: MatSort;
	@ViewChild('trigger', {static: true}) _trigger: MatMenuTrigger;
	@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

	// Selection
	selectedColumns = new SelectionModel<any>(true, this.availableColumns);
	selection = new SelectionModel<DeNghiMuaHang>(true, []);

	DeNghiMuaHangResult: DeNghiMuaHang[] = [];
	tmpDeNghiMuaHangResult: DeNghiMuaHang[] = [];

	loadingSubject = new BehaviorSubject<boolean>(false);
	loading$ = this.loadingSubject.asObservable();

	saveNewRecord: number[] = []
	listTT: any = [];
	previousIndex: number;
	fixedPoint = 2;
	isClearAll: boolean = false;
	openDialog: boolean = false;
	CoQuyen:string='0';

	//ROLES
	TAO = '172';
	HUY = '171';
	LIST_ROLES_USER : [] = [];
	SHOW_BUTTON_CREATE = new BehaviorSubject<boolean>(false);
	SHOW_BUTTON_REMOVE = new BehaviorSubject<boolean>(false);

	//filter on grid
	haveFilter: boolean = false;
	filterGroupDataChecked: any = {};
	filterGroupDataCheckedFake: any = {};
	filterGroupData: any = {};
	filterGroupArray: any = {};
	filterText: any = {};
	tmpfilterText: any = {};
	disableButtonFilter: any = {};

	//Loai phieu
	category_path = "PDNMH";

	constructor(
		private deNghiMuaHangService: DeNghiMuaHangService,
		private DungChungService: DungChungService,
		public dialog: MatDialog,
		private router: Router,
		private datePipe: DatePipe,
		private translate: TranslateService,
		private tokenStorage: TokenStorage,
		private subheaderService: SubheaderService,
		private changeDetect: ChangeDetectorRef,
		private hc_dangkytiepkhachsService: HC_DangKyTiepKhachService,
		private layoutUtilsService: LayoutUtilsService) {
			let user = JSON.parse(localStorage.getItem("UserInfo"));
			this.LIST_ROLES_USER = user.roles;
		}

	/*---------------------------- LOAD DATA --------------------------------*/
	ngOnInit() {

		/*Load cấu hình config form */
		this.CONFIG = new CommonConFig();
		this.listTT = DeNghiMuaHang.optionsTinhTrang
		this.haveFilter = true;
		this.tmpfilterText = Object.assign({}, this.filterText);
		this.disableButtonFilter['TinhTrang'] = true;

		this.filterGroupDataChecked['TinhTrang'] = DeNghiMuaHang.optionsTinhTrang.map(x => {
			return {
				id: x.id,
				name: x.name,
				value: x.value,
				checked: false
			}
		});
		this.filterGroupDataCheckedFake = Object.assign({}, this.filterGroupDataChecked);

		this.filterGroupDataChecked['LoaiPhieu'] = DeNghiMuaHang.optionsLoaiPhieu.map(x => {
			return {
				id: x.id,
				name: x.name,
				value: x.value,
				checked: false
			}
		});
		this.filterGroupDataCheckedFake = Object.assign({}, this.filterGroupDataChecked);

		this.hc_dangkytiepkhachsService.DM_PhongBan_Tree().subscribe(resPB => {
			if(resPB && resPB.status === 1){
				var i = 0;
				var arr = [];
				resPB.data.forEach(x => {
					x.Childrens.forEach(y => {
						arr.push(y);
					});
				});
				this.filterGroupDataChecked['PhongBanDN'] = arr.map(a =>{
					i = i + 1;
					return {
						id: i,
						name: a.TenPB,
						value: a.Id_PB,
						checked: false,
					}
				})
				this.filterGroupDataCheckedFake = Object.assign({}, this.filterGroupDataChecked);
			}
		});

		this.showColumnsInTable();
		this.applySelectedColumns();
		
		this.SHOW_BUTTON_CREATE.next(this.isTrueButton(this.TAO));
		this.SHOW_BUTTON_REMOVE.next(this.isTrueButton(this.HUY));
		
		this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
		merge(this.sort.sortChange, this.paginator.page)
			.pipe(
				tap(() => {
					this.loadDeNghiMuaHangListWithoutPageChange(false);
					this.forcusEvents();
				})
			)
			.subscribe();

		let breadcrumbs = [{ title: 'Mua hàng' }, { title: 'Đề nghị mua hàng', page: '/de-nghi-mua-hang' }];
		this.subheaderService.setBreadcrumbs(breadcrumbs);

		this.dataSource = new DeNghiMuaHangDataSource(this.deNghiMuaHangService);
		let queryParams = new QueryParamsModel({});

		this.dataSource.entitySubject.subscribe(res => {
			this.DeNghiMuaHangResult = res
			this.tmpDeNghiMuaHangResult = []
			if(this.DeNghiMuaHangResult != null){
				for(let i = 0; i < this.DeNghiMuaHangResult.length; i++){
					let tmpElement = new DeNghiMuaHang();
					tmpElement.copy(this.DeNghiMuaHangResult[i])
					this.tmpDeNghiMuaHangResult.push(tmpElement);
				}
			}
		});
		this.loadDeNghiMuaHangList();
		this.layoutUtilsService.setUpPaginationLabels(this.paginator);
	}
	loadDeNghiMuaHangListWithoutPageChange(isDeleteAction: boolean) {
		this.selection.clear();
		let moveToPreviousPage = this.DeNghiMuaHangResult.length == 1 && this.paginator.pageIndex > 0 ? true : false;
		if(moveToPreviousPage)
			this.paginator.pageIndex = this.paginator.pageIndex - 1
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize,
			this.filterGroupData
		);
		this.dataSource.loadPhieuDeNghiMuaHang(queryParams);
	}
	loadDeNghiMuaHangList() {
		this.selection.clear();
		this.paginator.pageIndex = 0;
		const queryParams = new QueryParamsModel(
			this.filterConfiguration(),
			this.sort.direction,
			this.sort.active,
			this.paginator.pageIndex,
			this.paginator.pageSize,
			this.filterGroupData
		);
		this.dataSource.loadPhieuDeNghiMuaHang(queryParams);
	}
	filterConfiguration(): any {
		const filter: any = {};
		filter.CoQuyen = this.CoQuyen;
		filter.Search = this.searchFullText? this.searchFullText.first.nativeElement.value : "";
		return filter;
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------- CÁC THAO TÁC TRÊN FORM ----------------------*/
	add() {
		if(this.checkDashboardRoute())	return null;
		const newItem = new DeNghiMuaHang();
		newItem.clear();
		this.DungChungService.getBillNumber(this.category_path).subscribe(res => {
			if (res.status == 1) {
				newItem.SoPhieu = res.data;
				newItem.TinhTrang = DeNghiMuaHang.optionsTinhTrang[0].value;
				const dialogRef = this.dialog.open(DeNghiMuaHangAddEditComponent, {
					data: { data: newItem },
					maxHeight: '90vh',
					width: '90vw'
				});

				dialogRef.afterClosed().subscribe(res => {
					
					this.forcusEvents();
					if (res == undefined || res == null) {
						return;
					}
					else{
						if (!res.isChange) {
							return;
						}
						if(res.dataAdd.length != 0){
							this.saveNewRecord = res.dataAdd;
						}
						this.loadDeNghiMuaHangList();
					}
				});
			}
			else {
				const message = `Lỗi lấy số phiếu tiếp theo`;
				this.forcusEvents();
				this.layoutUtilsService.showErorr(message);
			}
		});

	}
	edit(item: DeNghiMuaHang) {
		if(this.checkDashboardRoute())	return null;
		this.deNghiMuaHangService.getDeNghiMuaHangDetail(item.Id).subscribe(res => {
			if (res.status == 1) {
				item.listChiTietMuaHang = res.data.listChiTietMuaHang;
				item.listPhieuDeNghiLsThaoTac = res.data.listPhieuDeNghiLsThaoTac;
				const dialogRef = this.dialog.open(DeNghiMuaHangAddEditComponent, {
					data: { data: item },
					maxHeight: '90vh',
					width: '90vw'
				});

				dialogRef.afterClosed().subscribe(res => {
					this.forcusEvents();
					if (res == undefined || res == null) {
						return;
					}
					else{
						if (!res.isChange) {
							return;
						}
						if(res.dataAdd.length != 0){
							this.saveNewRecord = res.dataAdd;
						}
						this.loadDeNghiMuaHangListWithoutPageChange(false);
					}
				});
			}
			else {
				this.forcusEvents();
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	getDetail(item: DeNghiMuaHang){	
		if(this.checkDashboardRoute())	return null;	
		this.deNghiMuaHangService.getDeNghiMuaHangDetail(item.Id).subscribe(res => {
			if (res.status == 1) {
				item.TinhTrang = res.data.TinhTrang
				item.listChiTietMuaHang = res.data.listChiTietMuaHang;
				item.listPhieuDeNghiLsThaoTac = res.data.listPhieuDeNghiLsThaoTac;
				const dialogRef = this.dialog.open(DeNghiMuaHangDetailComponent, {
					data: { data: item },
					maxHeight: '90vh',
					width: '90vw'
				});

				dialogRef.afterClosed().subscribe(res => {
					this.forcusEvents();
					this.loadDeNghiMuaHangListWithoutPageChange(false);
				});
			}
			else {
				this.forcusEvents();
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	delete(item: DeNghiMuaHang) {
		if(this.checkDashboardRoute())	return null;
		const dialogRef = this.layoutUtilsService.POP01(item.SoPhieu);
		const _deleteMessage = `Phiếu đã được xóa`;

		dialogRef.afterClosed().subscribe(res => {
			this.forcusEvents();
			if (!res) {
				return;
			}
			this.deNghiMuaHangService.deleteDeNghiMuaHang(item.Id).subscribe(res => {
				if (res && res.status === 1) {
					this.layoutUtilsService.showInfo(_deleteMessage);
				}
				else {
                    this.layoutUtilsService.showErorr(res.error.message);
                }
				this.loadDeNghiMuaHangListWithoutPageChange(true);
			});
		});

	}
	cancel(item: DeNghiMuaHang) {
		if(this.checkDashboardRoute())	return null;
		const dialogRef = this.layoutUtilsService.POP04(item.SoPhieu);
		const _deleteMessage = `Phiếu đã được hủy`;
		dialogRef.afterClosed().subscribe(res => {
			if (!res) {
				return;
			}
			this.deNghiMuaHangService.cancelDeNghiMuaHang(item.Id).subscribe(res => {
				if (res && res.status === 1) {
					this.layoutUtilsService.showInfo(_deleteMessage);
					this.saveNewRecord = [];
					this.saveNewRecord = [item.Id];
				}
				else {
					this.layoutUtilsService.showErorr(res.error.message);
				}
				this.loadDeNghiMuaHangListWithoutPageChange(false);
			});
		});
	}
	confirm(item: DeNghiMuaHang) {
		if(this.checkDashboardRoute())	return null;
		this.deNghiMuaHangService.getDeNghiMuaHangDetail(item.Id).subscribe(res => {
			if (res.status == 1) {
				if(res.data.TinhTrang == DeNghiMuaHang.optionsTinhTrang[1].value){
					this.openDialog = true;
					item.listChiTietMuaHang = res.data.listChiTietMuaHang;
					item.listPhieuDeNghiLsThaoTac = res.data.listPhieuDeNghiLsThaoTac;
					
					const dialogRef = this.dialog.open(DuyetDeNghiMuaHangComponent, {
						data: { data: item },
						maxHeight: '90vh',
						width: '90vw'
					});
	
					dialogRef.afterClosed().subscribe(res => {
						this.forcusEvents();
						if (res == undefined || res == null) {
							return;
						}
						else{
							if (!res.isChange) {
								this.loadDeNghiMuaHangListWithoutPageChange(false);
								return;
							}
							if(res.dataAdd.length != 0){
								this.saveNewRecord = res.dataAdd;
							}
							this.loadDeNghiMuaHangListWithoutPageChange(false);
						}
					});
				}
				else if(res.data.TinhTrang == DeNghiMuaHang.optionsTinhTrang[8].value){
					this.layoutUtilsService.showErorr('Phiếu đã bị hủy, vui lòng tải lại danh sách để kiểm tra');
				}
			}
			else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	XacNhan(item: DeNghiMuaHang){
		if(this.checkDashboardRoute())	return null;
		this.deNghiMuaHangService.getDeNghiMuaHangDetail(item.Id).subscribe(res => {
			if (res.status == 1) {
				if(res.data.TinhTrang == DeNghiMuaHang.optionsTinhTrang[1].value){
					this.openDialog = true;
					item.listChiTietMuaHang = res.data.listChiTietMuaHang;
					item.listPhieuDeNghiLsThaoTac = res.data.listPhieuDeNghiLsThaoTac;
					const dialogRef = this.dialog.open(XacNhanMuaHangComponent, {
						data: { data: item },
						maxHeight: '90vh',
						width: '90vw'
					});

					dialogRef.afterClosed().subscribe(res => {
						this.forcusEvents();

						if (res == undefined || res == null) {
							return;
						}
						else{
							if (!res.isChange) {
								this.loadDeNghiMuaHangListWithoutPageChange(false);
								return;
							}
							if(res.dataAdd.length != 0){
								this.saveNewRecord = res.dataAdd;
							}
							this.loadDeNghiMuaHangListWithoutPageChange(false);
						}
					});
				}
				else if(res.data.TinhTrang == DeNghiMuaHang.optionsTinhTrang[8].value){
					this.layoutUtilsService.showErorr('Phiếu đã bị hủy, vui lòng tải lại danh sách để kiểm tra');
				}
			}
			else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	duyetGia(item: DeNghiMuaHang){
		if(this.checkDashboardRoute())	return null;
		this.deNghiMuaHangService.getDeNghiMuaHangDetail(item.Id).subscribe(res => {
			if (res.status == 1) {
				if(res.data.TinhTrang == DeNghiMuaHang.optionsTinhTrang[2].value){
					this.openDialog = true;
					item.listChiTietMuaHang = res.data.listChiTietMuaHang;
					item.listPhieuDeNghiLsThaoTac = res.data.listPhieuDeNghiLsThaoTac;
					const dialogRef = this.dialog.open(DuyetGiaComponent, {
						data: { data: item },
						maxHeight: '90vh',
						width: '90vw'
					});

					dialogRef.afterClosed().subscribe(res => {
						this.forcusEvents();

						if (res == undefined || res == null) {
							return;
						}
						else{
							if (!res.isChange) {
								return;
							}
							if(res.dataAdd.length != 0){
								this.saveNewRecord = res.dataAdd;
							}
							this.loadDeNghiMuaHangListWithoutPageChange(false);
						}
					});
				}
				else if(res.data.TinhTrang == DeNghiMuaHang.optionsTinhTrang[8].value){
					this.layoutUtilsService.showErorr('Phiếu đã bị hủy, vui lòng tải lại danh sách để kiểm tra');
				}
			}
			else {
				this.layoutUtilsService.showErorr(res.error.message);
			}
		});
	}
	xuly(item: DeNghiMuaHang){
		if(item.TinhTrang == DeNghiMuaHang.optionsTinhTrang[1].value){
			this.XacNhan(item)
		}
		else if(item.TinhTrang == DeNghiMuaHang.optionsTinhTrang[10].value){
			this.confirm(item);
		}
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------ THAY ĐỔI DỮ LIỆU TRÊN LƯỚI ---------------------*/
	changeValueOfColumn(columnName:string, item:any, event: any, afterUpdate: boolean){
		if(columnName == 'DienGiaiLyDo'){
			if(afterUpdate){
				this.tmpDeNghiMuaHangResult[this.DeNghiMuaHangResult.indexOf(item)].DienGiaiLyDo = item.DienGiaiLyDo
			}
			else{
				this.DeNghiMuaHangResult[this.DeNghiMuaHangResult.indexOf(item)].DienGiaiLyDo = event.target.value.trim();
			}
		}
	}
	resetValueUpdate(columnName:string, item:any){
		if(columnName == 'DienGiaiLyDo')
			this.DeNghiMuaHangResult[this.DeNghiMuaHangResult.indexOf(item)].DienGiaiLyDo = this.tmpDeNghiMuaHangResult[this.DeNghiMuaHangResult.indexOf(item)].DienGiaiLyDo;
	}
	isChangeValue(columnName:string, item:any){
		if(columnName == 'DienGiaiLyDo' && this.DeNghiMuaHangResult[this.DeNghiMuaHangResult.indexOf(item)].DienGiaiLyDo != this.tmpDeNghiMuaHangResult[this.DeNghiMuaHangResult.indexOf(item)].DienGiaiLyDo)
			return true;
		return false;
	}
	/* -----------------------------------------------------------------------*/


	/*------------------------ CÁC HÀM XÁC NHẬN CẤP QUYỀN ---------------------*/
	isTrueButton(ROLENUMBER: string) {
		if (this.LIST_ROLES_USER.findIndex(x => x == ROLENUMBER) > -1) {
			return true;
		}
		return false;
	}
	isCreate(item:any){
		
		var idUser = '';
		this.tokenStorage.getIDUser().subscribe(t => { idUser = t; });
		let element = this.tmpDeNghiMuaHangResult.find(x => x.Id == item.Id);
		if(element != null && (element.Nguoitao == +idUser || element.NguoiYeuCau == +idUser )){
			return true;
		}
		return false;
	}
	/* -----------------------------------------------------------------------*/


	/*----------------------- CSS HIỂN THỊ CHO TRẠNG THAI --------------------*/
	getItemCssClassByStatus(status: any): string {
		switch (status) {
			case DeNghiMuaHang.optionsTinhTrang[0].value:
				return '_phieumoi';
			case DeNghiMuaHang.optionsTinhTrang[1].value:
				return '_choxacnhan';
			case DeNghiMuaHang.optionsTinhTrang[2].value:
				return '_hoantat';
			case DeNghiMuaHang.optionsTinhTrang[3].value:
				return '_dahuy';
			default:
				return 'success';
		}
	}
	highlightNewestRecord(item : any){
		var index = this.DeNghiMuaHangResult.indexOf(item);
		if(this.saveNewRecord.indexOf(this.DeNghiMuaHangResult[index].Id) > -1){
			return true;
		}
		return false;
	}
	/* -----------------------------------------------------------------------*/


	/*----------------------- CÁC HÀM SỰ KIỆN FOCUS --------------------------*/
	forcusEvents(){
		this.openDialog = false;
		this.changeDetectView();
	}
	disabledDialog(){
		this.openDialog = true;
		this.changeDetectView();
	}
	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
        if(event.altKey && event.keyCode == this.CONFIG.BUTTON_FORM.ADD_NEW.KeyCombine.keycode && !this.openDialog) {
			this.openDialog = true;
			this.add();
		}
	}
	checkDashboardRoute(){
		/* 
			Kiểm tra xem có phải đang ở dashboard không, nếu là trang dashboard thì không thực hiện
			các action trên component hiện tại.
		*/
		if(this.router.url === '/')
			return true;
		return false;
	}
	changeDetectView(){
		if (!(this.changeDetect as ViewRef).destroyed) {
			this.changeDetect.detectChanges()
		}
	}
	/* -----------------------------------------------------------------------*/


	/*-------------------- HÀM HỖ TRỢ FORMAT DẠNG SỐ -----------------------*/
	ValidateChangeNumberEvent(columnName: string, item: any, event: any) {
		var count = 0;
		for (let i = 0; i < event.target.value.length; i++) {
			if (event.target.value[i] == '.') {
				count += 1;
			}
		}
		var regex = this.CONFIG.REGEX_SPECIAL_CHARACTER;
		var found = event.target.value.match(regex);
		if (found != null) {
			const message = 'Dữ liệu không gồm chữ hoặc kí tự đặc biệt';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		if (count >= 2) {
			const message = 'Dữ liệu không thể có nhiều hơn 2 dấu .';
			this.layoutUtilsService.showErorr(message);
			return false;;
		}
		return true;
	}
	formatNumber(item: string) {
		if (item == '' || item == null || item == undefined) return '';
		return Number(Math.round(parseFloat(item + 'e' + this.fixedPoint)) + 'e-' + this.fixedPoint).toFixed(this.fixedPoint)
	}
	f_currency(value: string): any {
		if (value == null || value == undefined || value == '') value = '0.00';
		let nbr = Number((value.substring(0, value.length - (this.fixedPoint + 1)) + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,") + value.substr(value.length - (this.fixedPoint + 1), (this.fixedPoint + 1));
	}
	f_currency_V2(value: string): any {
		if (value == null || value == undefined || value == '') return '';
		let nbr = Number((value + '').replace(/,/g, ""));
		return (nbr + '').replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
	}
    /* -----------------------------------------------------------------------*/


	/*-------------------- HÀM HỖ TRỢ FORMAT DẠNG NGÀY -----------------------*/
	getFormatDate(v: string = '') {
		if (v != '') {
			return v.includes('T') ? v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})(T)(\d{2})(:)(\d{2})(:)(\d{2}).*$/g, "$5/$3/$1") : v.replace(/(\d{4})(-)(\d{2})(-)(\d{2})/g, "$5/$3/$1");
		}
		return '';
	}
	f_convertDate(p_Val: any) {
		if (p_Val == null || p_Val == undefined || p_Val == '') return '';
		let a = p_Val === "" ? new Date() : new Date(p_Val);
		return ("0" + (a.getDate())).slice(-2) + "/" + ("0" + (a.getMonth() + 1)).slice(-2) + "/" + a.getFullYear();
	}
	getFirstDay_LastDay(b_firstday) {
		var date = new Date(), y = date.getFullYear(), m = date.getMonth();
		var firstDay = new Date(y, m, 1);
		var lastDay = new Date(y, m + 1, 0);
		var curent = new Date();
		return b_firstday ? this.datePipe.transform(firstDay, 'dd/MM/yyyy') : this.datePipe.transform(curent, 'dd/MM/yyyy');
	}
    /* -----------------------------------------------------------------------*/


	/* ---------- HÀM HỖ TRỢ HIỂN THỊ CỘT TRÊN MENU --------------------------*/
	IsAllColumnsChecked() {
		const numSelected = this.selectedColumns.selected.length;
		const numRows = this.availableColumns.length;
		return numSelected === numRows;
	}
	CheckAllColumns() {
		if (this.IsAllColumnsChecked()) {
			this.availableColumns.forEach(row => { if (!row.alwaysChecked) this.selectedColumns.deselect(row); });
		} else {
			this.availableColumns.forEach(row => this.selectedColumns.select(row));
		}
	}
	menuChange(e: any, type: 0 | 1 = 0) {
		this.layoutUtilsService.menuSelectColumns_On_Off();
	}
	/*----------------------------------------------------------------------- */


	/*-------- CÁC HÀM HỖ TRỢ CHUYỂN CỘT VÀ HIỂN THỊ CỘT TRONG BẢNG ----------*/
	showColumnsInTable() {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].isShow == false) {
				this.selectedColumns.toggle(this.availableColumns[i]);
			}
		}
	}
	findIndexColumn(column: string) {
		for (let i = 0; i < this.availableColumns.length; i++) {
			if (this.availableColumns[i].name == column)
				return i;
		}
	}
	dragStarted(event: CdkDragStart, column: string) {
		this.previousIndex = this.findIndexColumn(column);
	}
	dropListDropped(event: CdkDropList, column: string) {
		if (event) {
			moveItemInArray(this.availableColumns, this.previousIndex, this.findIndexColumn(column));
			this.applySelectedColumns();
		}
	}
	applySelectedColumns() {
		let _selectedColumns = this.selectedColumns.selected;
		this.selectedColumns = new SelectionModel<any>(true, this.availableColumns);
		for (let i = 0; i < this.availableColumns.length; i++) {
			this.selectedColumns.toggle(this.availableColumns[i]);
			for (let j = 0; j < _selectedColumns.length; j++) {
				if (this.availableColumns[i].name == _selectedColumns[j].name) {
					this.selectedColumns.toggle(this.availableColumns[i]);
					break;
				}
			}
		}
		const _applySelectedColumns: string[] = [];
		this.selectedColumns.selected.forEach(col => { _applySelectedColumns.push(col.name) });
		this.displayedColumns = _applySelectedColumns;
	}
    /*----------------------------------------------------------------------- */


	/*-----------------------------FILTER ON GRID ----------------------------*/
	removeText(col) {
		this.filterText[col] = "";
		this.loadDeNghiMuaHangList();
		this.forcusEvents();
	}
	/* ---------------------------------------------------------------------- */
//#region Filter function
	SelectAll(event, col) {
		if (event.checked) {
			this.filterGroupDataCheckedFake[col].forEach(element => {
				element.checked = true;
			});
		}
		else {
			this.filterGroupDataCheckedFake[col].forEach(element => {
				element.checked = false;
			});
		}
	}
	isColumnSelectAll(col) {
		if (this.filterGroupDataCheckedFake[col]) {
			let lst_checked = this.filterGroupDataCheckedFake[col].filter(opt => opt.checked).map(opt => opt.value);
			if (lst_checked) {
				if (lst_checked.length != this.filterGroupDataCheckedFake[col].length) {
					return false;
				}
				else {
					return true;
				}
			}
			else {
				return false;
			}
		}
		return false;
	}
	LoadDataDropFilter(col) {
		this.tmpfilterText = Object.assign({}, this.filterText);
		if (this.filterGroupDataChecked && this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col] && this.filterGroupDataChecked[col]) {
			this.filterGroupDataCheckedFake[col] = this.filterGroupDataChecked[col].map(x => Object.assign({}, x));
		}
	}
	// isSelect : true list chon | false là nhap text
	disableDoneButton(col , isSelect = true) {
		let countChecked = 0;
		
		if(isSelect){
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				for (var elementFake of this.filterGroupDataCheckedFake[col]) {
					if (elementFake.checked) {
						countChecked++;
					}
				}
			}
			if (countChecked > 0) {
				this.disableButtonFilter[col] = false;
			}
			else {
				this.disableButtonFilter[col] = true;
			}
		}else{
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				if (this.filterGroupDataCheckedFake[col].length > 0) {
					this.disableButtonFilter[col] = false;
				}
				else {
					this.disableButtonFilter[col] = true;
				}
			}
		}
	}
	showClearAllButton() {
		let _count = 0;
		for (var key in this.filterGroupArray) {
			if (this.filterGroupArray.hasOwnProperty(key)) {
				if (this.filterGroupArray[key]) {
					let _arrflt = this.filterGroupArray[key].filter(opt => opt.checked);
					_count += _arrflt ? _arrflt.length : 0;
				}
			}
		}
		let _text = "";
		for (var key in this.filterText) {
			if (this.filterText.hasOwnProperty(key)) {
				_text += this.filterText[key];
			}
		}
		if (_count > 0 || _text) {
			this.isClearAll = true;
		}
		else {
			this.isClearAll = false;
		}
	}
	filterHead(col, isSelect = true) {
		if(isSelect){
			if (this.filterGroupDataCheckedFake && this.filterGroupDataCheckedFake[col]) {
				for (var elementFake of this.filterGroupDataCheckedFake[col]) {
					
					let index = this.filterGroupDataChecked[col].findIndex(x => x.id == elementFake.id);
					
					if (index > -1)
						this.filterGroupDataChecked[col][index].checked = elementFake.checked;
				}
				this.filterGroupData[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupArray[col] = this.filterGroupDataCheckedFake[col]
					.filter(opt => opt.checked);
				this.filterGroupData[col] = this.filterGroupDataCheckedFake[col]
					.filter(opt => opt.checked).map(op => op.value);

				this.filterGroupDataCheckedFake[col] = this.filterGroupDataChecked[col].map(x => Object.assign({}, x));
				this.tmpfilterText[col] = '';
			}
			this.filterText = Object.assign({}, this.tmpfilterText);
			if (this.filterText) {
				this.filterConfiguration();
			}
			this.loadDeNghiMuaHangList();
			this.isClearAll = this.checkFilterHasValue(this.filterGroupDataChecked, 'ALL');
		}else{
			if (this.filterGroupDataCheckedFake ) {
				if(!this.filterGroupDataCheckedFake[col]){
					this.remove('', col, false);
				}else{
					this.filterGroupData[col] = [];
					this.filterGroupArray[col] = [this.filterGroupDataCheckedFake[col]];
					this.filterGroupData[col] = [this.filterGroupDataCheckedFake[col]];
					if(this.filterGroupData[col]) 
						this.tmpfilterText[col] = '';
				}
			}
			this.filterText = Object.assign({}, this.tmpfilterText);
			if (this.filterText) {
				this.filterConfiguration();
			}
			this.loadDeNghiMuaHangList();
			this.isClearAll = this.checkFilterHasValue(this.filterGroupDataCheckedFake, col, false);
			this.filterGroupDataCheckedFake[col] = '';
		}
	}
	remove(item, col, isSelect = true) {
		if(isSelect){
			let _index = this.filterGroupDataChecked[col].findIndex(x => x.value == item.value);
			if (_index > -1) {
				this.filterGroupDataChecked[col][_index].checked = false;
				this.filterGroupData[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupArray[col] = this.filterGroupDataChecked[col]
					.filter(opt => opt.checked);
				this.filterGroupData[col] = this.filterGroupDataChecked[col]
					.filter(opt => opt.checked).map(op => op.value);

				if (this.filterGroupData[col] != null && this.filterGroupData[col].length == 0) {
					this.filterGroupData[col] = null
					this.filterText[col] = '';
					this.disableButtonFilter[col] = true;
				}
				this.loadDeNghiMuaHangList();
			}
		}else{
			let _index = this.filterGroupDataCheckedFake[col].length;
			if (_index > -1) {
				this.filterGroupData[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupArray[col] = [];
				this.filterGroupData[col] = [];

				if (this.filterGroupData[col] != null && this.filterGroupData[col].length == 0) {
					this.filterGroupData[col] = null
					this.filterText[col] = '';
					this.disableButtonFilter[col] = true;
				}
				this.filterGroupDataCheckedFake[col] = '';
				this.loadDeNghiMuaHangList();
			}
		}
		
	}
	Clear() {
		this.filterGroupData = [];
		this.filterGroupArray = [];
		for (var key in this.filterGroupDataChecked) {
			if (this.filterGroupDataChecked.hasOwnProperty(key)) {
				if (this.filterGroupDataChecked[key]) {
					this.filterGroupDataChecked[key].forEach(element => {
						element.checked = false;
					});
					this.disableButtonFilter[key] = true;
				}
			}
		}
		for (var key in this.filterText) {
			if (this.filterText.hasOwnProperty(key)) {
				this.filterText[key] = "";
			}
		}
		this.isClearAll = false;
		this.loadDeNghiMuaHangList();
		this.forcusEvents();
	}
	checkFilterHasValue(data, col, isSelect = true) {
		
		let _count = 0;
		if(isSelect){
			if (col == 'ALL' && data) {//check all column
				for (var key in data) {
					if (data.hasOwnProperty(key)) {
						if (data[key]) {
							let _arrflt = data[key].filter(opt => opt.checked);
							_count += _arrflt ? _arrflt.length : 0;
						}
					}
				}
				let _text = "";
				for (var key in this.filterText) {
					if (this.filterText.hasOwnProperty(key)) {
						_text += this.filterText[key];
					}
				}
				if (_count > 0 || _text) {
					return true;
				}
			}
			else {//check in 1 column
				if (data && data[col]) {
					let _arrflt = data[col].filter(opt => opt.checked);
					_count += _arrflt ? _arrflt.length : 0;
				}
				if (_count > 0) {
					return true;
				}
			}
		}else{
			if(data && data[col] && data[col].length > 0){
				if (data[col].length > 0) {
					return true;
				}
			}
		}
		return false;
	}
	filterGroupWithTextFilter(columnName: string) {
		let search = this.tmpfilterText[columnName]

		if (!search) {
			this.filterGroupDataCheckedFake[columnName] = this.filterGroupDataChecked[columnName].map(x => Object.assign({}, x));
			return;
		} else {
			search = search.toLowerCase();
		}

		this.filterGroupDataCheckedFake[columnName] = this.filterGroupDataChecked[columnName].filter(
			ts => ts.name.toLowerCase().indexOf(search) > -1)

		this.changeDetect.detectChanges();
	}
	//#endregion Filter function
	getTenLoaiPhieu(value: string){
		return DeNghiMuaHang.optionsLoaiPhieu.find(x => x.value == value) ? DeNghiMuaHang.optionsLoaiPhieu.find(x => x.value == value).name : '';
	}
}
